import React, { useState, useEffect } from "react";
import { numberFormatCommaTwoFraction } from "../../../common/js/utils/numberFormat";
import ConnectAPI from "../../../services/api";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";

const connectApi = new ConnectAPI();
function SpecialConditionDetailTypes_21({ specialCondition }) {
    const [t] = useTranslation();
    const [familyType, setFamilyType] = useState("");
    const [serie, setSerie] = useState(0);
    var fetchData;
    useEffect(() => {
        fetchData = async () => {
            connectApi.getWithParams("api/Channels/specialConditionsRunLength", specialCondition.idPress, getSCdataCallback)
                .catch((error) => {
                    Swal.fire(
                        "Error " + error?.response?.status,
                        error?.response?.data,
                        "error"
                    );
                });
        }
        fetchData();
    }, [specialCondition.idSpecialCondition]);
    let getSCdataCallback;
    getSCdataCallback = (status, data) => {
        let items = data.split(",");
        setFamilyType(items[0]);
        setSerie(parseInt(items[1]));
    }
    
    return (<>
        <div>
            ThresHold: {specialCondition.threshold}
        </div>
        {serie>=4?(<div>{t('committedPPIRL')}: {specialCondition.percentage}</div>):(<div>{t('bonusPercentage')}: {numberFormatCommaTwoFraction(specialCondition.percentage * 100)}%</div>)}
        {familyType==="L&P"?(<div>{t('minimumMetters')}: {specialCondition.minimumImp}</div>):(<div>{t('minimumSheets')}: {specialCondition.minimumImp}</div>)}
    </>);
}
export default SpecialConditionDetailTypes_21;